import React from 'react'
import { render } from 'react-dom'
import Template from './components/Template'
import "@babel/polyfill"

render(<Template/>, document.getElementById('store-locator-template'))